var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-989.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transactions-icon",
    transform: "translate(989.000000, 177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Color-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style",
    opacity: 0,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Background-Color",
    fill: "#F6931E",
    opacity: 0.159999996,
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-caution-2145629",
    transform: "translate(9.000000, 10.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2211584,1.70200893 C14.6257245,0.671160323 13.5258557,0.0361744204 12.3353795,0.0361744204 C11.1449033,0.0361744204 10.0450345,0.671209273 9.44960056,1.70200893 L0.451519424,17.287359 C-0.143718672,18.3183545 -0.143718672,19.58862 0.451519424,20.6194196 C1.04675752,21.6504151 2.14682213,22.28545 3.33710252,22.28545 L21.3332648,22.28545 C22.5235452,22.28545 23.6236098,21.6504151 24.2188479,20.6194196 C24.814086,19.588571 24.814086,18.3183545 24.2188479,17.287359 L15.2211584,1.70200893 Z M12.3353795,19.5865641 C11.994449,19.5865641 11.6676457,19.4509957 11.4265645,19.2100662 C11.1854441,18.9689458 11.0500666,18.6421425 11.0500666,18.3012512 C11.0500666,17.9603599 11.1854441,17.6333216 11.4265645,17.3924362 C11.6676848,17.1513158 11.9944882,17.0159383 12.3353795,17.0159383 C12.6762708,17.0159383 13.0033091,17.1513158 13.2441945,17.3924362 C13.4853148,17.6333656 13.6206924,17.9603599 13.6206924,18.3012512 C13.6206924,18.6421425 13.4853148,18.968985 13.2441945,19.2100662 C13.0030741,19.4509957 12.6762708,19.5865641 12.3353795,19.5865641 Z M14.1499745,6.69006501 L13.696037,14.407601 C13.6686937,14.8747357 13.4034794,15.2952205 12.9936952,15.5212249 C12.5839256,15.7472392 12.0867892,15.7472392 11.6770246,15.5212249 C11.2672551,15.2952107 11.0020461,14.8747357 10.974487,14.407601 L10.5205494,6.69006501 C10.4911028,6.19023144 10.669124,5.70053062 11.0127467,5.33628994 C11.3561638,4.97202968 11.8345767,4.7655271 12.3353893,4.7655271 C12.836006,4.7655271 13.3143993,4.97203947 13.6580318,5.33628994 C14.0014489,5.7005502 14.1794525,6.19023144 14.1500333,6.69006501 L14.1499745,6.69006501 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/Expired.dd2dd42c7f65c76ac382bda130094c0a.svg";
export { ForwardRef as ReactComponent };